module.exports = __webpack_public_path__ + "img/nature-and-relax.4fe13faa.svg";